import { Tab } from 'types'

export const carrierPayablesTabs: Tab[] = [
  { id: 'to-delivery', label: 'To Delivery' },
  { id: 'invoice-pending', label: 'Invoice Pending' },
  { id: 'to-pay', label: 'To Pay' },
  { id: 'paid', label: 'Paid' },
]

export const carrierPayablesTableHeaders: Tab[] = [
  { id: 'load', label: 'Load#' },
  { id: 'order', label: 'Order#' },
  { id: 'carrier', label: 'Carrier' },
  { id: 'aging', label: 'Aging' },
  { id: 'amount', label: 'Amount' },
  { id: 'documents', label: 'Documents' },
  { id: 'action', label: 'Action' },
]